import React, {memo} from 'react';
import classes from './MainCard.module.scss';

const MainCard = memo(({children, ...props}) => {
    return (
        <div className={classes.wrapper}>
            {children
                ? <div className={classes.children}>{children}</div>
                : <>
                    <div className={classes.img_card}>
                        <img className={classes.img} src={props.img} alt=""/>
                    </div>
                    <div className={classes.param}>
                        {props.info.map((item) =>
                            <div className={classes.block_info} key={item.key}>
                                <div className={classes.info_key}>{item.key}</div>
                                <div onClick={item?.function
                                    ? () => {
                                        item?.function(item.value, 'success')
                                    }
                                    : undefined}
                                     className={item?.function
                                         ? classes.copy
                                         : classes.info_value}>{item.value}</div>
                            </div>)}
                    </div>
                </>
            }
        </div>
    );
});

export default MainCard;